@if (paramsExists) {
  <div class="reset-result">
    <button class="btn btn-sm btn-link" (click)="clear()" translate>Clear Search</button>
  </div>
}
